import React, { useEffect, useState } from 'react';
import { makeStyles } from "@material-ui/core"
import { appConfig } from '../config.js';


// const backgroundColor = 'rgb(170,20,20)'  // dark red
const backgroundColor = appConfig.theme.primaryColor

const useStyles = makeStyles({
    switch: {
        position: 'relative',
        display: 'inline-block',
        width: '40px',
        height: '23px',
    },
    switchInput: {
        opacity: 0,
        width: 0,
        height: 0,
    },
    slider: {
        position: 'absolute',
        cursor: 'pointer',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: '#ccc',
        transition: '.4s',
        borderRadius: '24px', // make it rounded
        '&:before': {  // white circle
            position: 'absolute',
            content: '""',
            height: '18px',
            width: '18px',
            left: '3px',
            bottom: '3px',
            backgroundColor: 'white',
            // -webkit-transition: .4s;
            WebkitTransition: '.4s',
            transition: '.4s',
            borderRadius: "50%",
        },
    },
    sliderChecked: {
        backgroundColor: backgroundColor,
        '&:before': {
            WebkitTransform: 'translateX(16px)',
            msTransform: 'translateX(16px)',
            transform: 'translateX(16px)',
        },
    },
});


/**
 * 
 * @param {*} props.onChange - (required) callback function
 * @param {*} props.checked - (optional) boolean
 * @returns 
 */
const SwitchSlider = ({ onChange, checked }) => {
    const classes = useStyles();
    const [isChecked, setIsChecked] = useState(checked);

    // allow props.checked to override var
    useEffect(() => {
        setIsChecked(checked);
    }, [checked]);

    const handleInputChange = () => {
        setIsChecked(!isChecked);
        onChange(!isChecked);
    };

    let label_classes = classes.switch

    let span_classes = classes.slider + " "
        + (isChecked ? classes.sliderChecked : '')

    return (
        <label className={label_classes}>
            <input
                onChange={handleInputChange}
                checked={isChecked}
                type="checkbox"
                className={classes.switchInput}
            />
            <span className={span_classes} />
        </label>
    );
};

export default SwitchSlider;
